export default __webpack_public_path__ + "static/media/cupom-sat-nfe.bbaf9062.svg";